export default __webpack_public_path__ + "static/media/bgFeaturedRaceMb.39e80b53.png";